/** @jsx jsx */
import { jsx, Flex, Radio, Label } from 'theme-ui';

const ContentfulRadioField = ({ field, id, label, ...props }) => {
  return (
    <Flex sx={{ my: 2 }}>
      <Label sx={{ fontWeight: 'normal', m: 0 }} htmlFor={id}>
        <Radio
          name={field.name}
          id={id}
          value={id}
          checked={id === props.fieldValue}
          onChange={field.onChange}
          onBlur={field.onBlur}
          {...props}
        />
        {label}
      </Label>
    </Flex>
  );
};

export default ContentfulRadioField;
